/* eslint-disable @typescript-eslint/naming-convention */

export interface IIrctcPayload {
    encoded_payload: string;
    coach?: string;
    berth?: string;
    station_name?: string;
    platform_number?: string;
    mobile_number?: string;
}

export interface IIrctcTrainOrderAttributes {
    train_number: string;
    train_name: string;
}

export enum IrctcAddressChangeFormKeys {
    COACH_NO = "coachNo",
    SEAT_NO = "seatNo",
    CONTACT_NO = "contactNo",
}
